/**
 * Twarde spacje w słownikach interfejsu — jedyny punkt składu typograficznego.
 *
 * Słowniki (`apps/*\/src/i18n/*.ts`) trzymają zwykłe spacje; NBSP powstaje tu,
 * raz, przy budowie `DICTS`. Skład robi `@no-human/typografia` (`typeset`):
 * dla `pl` wiąże sieroty z listy wspólnej i pauzy, dla `en` nie zmienia nic.
 * Pozostałe języki interfejsu paczka nie obsługuje, więc zostają bez zmian.
 */
import { typeset } from "@no-human/typografia";
import { LANGS } from "./lang.js";
export function typesetDict(dict, lang) {
    if (lang !== "pl")
        return dict;
    const out = {};
    for (const [k, v] of Object.entries(dict))
        out[k] = typeset(v, "pl");
    return out;
}
/** Cały zestaw słowników językowych naraz — jedyna pętla po `LANGS` w warstwach i18n. */
export function typesetDicts(raw) {
    const out = {};
    for (const l of LANGS)
        out[l] = typesetDict(raw[l], l);
    return out;
}
/**
 * Pierwsze słowo napisu, znak oddzielający (zwykła albo twarda spacja — `\s` łapie oba)
 * i reszta. Do składania napisu z akcentem na końcu (np. „albo zaloguj się e-mailem”):
 * separator wraca taki, jaki był, więc skład (sierota „albo”) się nie psuje.
 */
export function splitLead(text) {
    const m = /^(\S+)(\s)([\s\S]*)$/.exec(text);
    return m ? { lead: m[1] ?? "", sep: m[2] ?? "", rest: m[3] ?? "" } : { lead: text, sep: "", rest: "" };
}
//# sourceMappingURL=typeset.js.map